module.exports = __webpack_public_path__ + "img/dial-med.1daa5921.svg";